import { render, staticRenderFns } from "./ModalCompreende.vue?vue&type=template&id=30ccf721&scoped=true&"
import script from "./ModalCompreende.vue?vue&type=script&lang=js&"
export * from "./ModalCompreende.vue?vue&type=script&lang=js&"
import style0 from "./ModalCompreende.vue?vue&type=style&index=0&id=30ccf721&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ccf721",
  null
  
)

export default component.exports